import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_NEW_PETITION_PAGE_GOOGLE_ADDRESS_EXPERIMENT = createFcmDetails(
	'new_petition_page_google_address_experiment',
	{
		owner: 'Capybara Squad',
		context: 'Petition Details',
		import: false,
		description: `
		Determines whether the new petition page Google address experiment is active and which experiment name to use:

		- If just "experimentName" is set, then one experiment is used with no geo-reach split.
		- If "localExperimentName" is set, then petitions with local geo-reach will use this experiment instead. The "experimentName" should also be set; it will be used for non-local petitions.

		The experiments with these names should be configured with the following variations:
		- optional - The address field will be shown but the form can be submitted with the field blank.
		- mandatory - The address field is shown and must be filled to submit the form.
		- control (default) - The address field is not shown.
		`,
		template: {
			enabled: false,
			experimentName: 'google_address_experiment',
			localExperimentName: 'google_address_experiment_local',
		},
	},
);
